import { Icon, Text } from 'ui';
import { SearchItemRow } from '../search-item-row';

const NoResultsItem = () => (
  <SearchItemRow icon={<Icon icon="search-2-line" size="small" />}>
    <Text>No results found</Text>
  </SearchItemRow>
);

export default NoResultsItem;
